import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

/** createI18n で初期化した i18next の翻訳リソース取得 (ready) を待って children を render する。 */
export function I18nProvider({ children }: { children: ReactNode }) {
  const { ready } = useTranslation();
  if (!ready) return null;
  return <>{children}</>;
}
